import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from '../../translations/i18n';
import { API_ENDPOINT } from '../../constants.js';
import Cookies from 'js-cookie'
import { getLinkedContact, getLinkedAddresses } from '../../actions';

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
    getContact: (user) => dispatch(getLinkedContact(user)),
    getAddresses: (user) => dispatch(getLinkedAddresses(user))
})

class ErpConnector extends Component {
    constructor(props) {
        super(props)
        this.state = {
            usr: '',
            pwd: '',
            username: '',
            connection: false
        }
        this.newConnection = this.newConnection.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {
        this.checkErpConnection()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.connection && this.state.usr !== '' && (prevState.usr !== this.state.usr || prevState.connection !== this.state.connection)) {
            this.props.getContact(this.state.usr)
            this.props.getAddresses(this.state.usr)
        }
    }

    handleChange(event) {
        const name = event.target.name;
        this.setState({
            [name]: event.target.value
        });
    }

    checkErpConnection() {
        const url = API_ENDPOINT + "/api/method/davrontranslations.davrontranslations.api.get_logged_user"
        const options = {
            method: 'GET',
            credentials: 'include'
        }

        return fetch(url, options)
        .then(result => {
            return result.status === 200 ? result.json() : result
        })
        .then(result => {
            if (result&&result.message) {
                this.setState({
                    connection: true,
                    usr: result.message.user,
                    username: result.message.full_name
                })
            }
        }).catch(err => console.log(err));
    }

    newConnection(event) {
        event.preventDefault();

        const url = API_ENDPOINT + "/api/method/login"
        const formData = new FormData()
        formData.append('usr', this.state.usr);
        formData.append('pwd', this.state.pwd);
        const options = {
            method: 'POST',
            credentials: 'include',
            body: formData
        }

        return fetch(url, options)
        .then(result => {
            this.setState({
                connection: result.status === 200 ? true : false
            })
            return result.status === 200 ? result.json() : result
        })
        .then(result => {
            result&&result.full_name&&this.setState({
                username: result.full_name
            })
        }).catch(() => {});
    }

    logout(event) {
        event.preventDefault();
        const url = API_ENDPOINT + "/api/method/frappe.handler.logout"
        const options = {
            method: 'POST',
            credentials: 'include'
        }

        return fetch(url, options)
        .then(result => {
            if (result.status === 200) {
                this.setState({
                    connection: false
                })
            } else if (result.status === 400) {
                const domainName = API_ENDPOINT.substr(8)
                Cookies.remove('csrf_token', { path: '/', domain: domainName })
                Cookies.remove('user_id', { path: '/', domain: domainName })
                Cookies.remove('user_image', { path: '/', domain: domainName })
                Cookies.remove('system_user', { path: '/', domain: domainName })
                Cookies.remove('full_name', { path: '/', domain: domainName })
                Cookies.remove('sid', { path: '/', domain: domainName })
            }
            return result.status === 200 ? result.json() : result
        })
        .then(() => {
            if (!this.state.connection) {
                this.setState({
                    usr: '',
                    pwd: '',
                    username: ''
                })
            }
        }).catch(() => {});

    }
    
    render() {
        const lng = this.props.lng;
        return(
            <li className="nav-item dropdown">
                {!this.state.connection&&<a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {i18n.t('app.connection', {lng})}
                </a>}
                {!this.state.connection&&<div className="dropdown-menu">
                    <form className="px-4 py-3">
                        <div className="form-group">
                            <label htmlFor="username">{i18n.t('app.email_address', {lng})}</label>
                            <input type="email" className="form-control" id="username" name="usr" placeholder={i18n.t('app.email_placeholder', {lng})} value={this.state.usr} onChange={this.handleChange}></input>
                        </div>
                        <div className="form-group">
                            <label htmlFor="password_field">{i18n.t('app.password', {lng})}</label>
                            <input type="password" className="form-control" id="password_field" name="pwd" placeholder={i18n.t('app.password_placeholder', {lng})} value={this.state.pwd} onChange={this.handleChange}></input>
                        </div>
                        <button type="submit" className="btn btn-primary" onClick={this.newConnection}>{i18n.t('app.login', {lng})}</button>
                    </form>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="https://dashboard.davrontranslations.com/#signup" rel="noopener">{i18n.t('app.no_account', {lng})}</a>
                    <a className="dropdown-item" href="https://dashboard.davrontranslations.com/#forgot" rel="noopener">{i18n.t('app.password_forgotten', {lng})}</a>
                </div>}
                {this.state.connection&&<a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {this.state.username}
                </a>}
                {this.state.connection&&<div className="dropdown-menu">
                    <a className="dropdown-item" onClick={this.logout}>{i18n.t('app.logout', {lng})}</a>
                </div>}
            </li>
        )
    }
  }


  export default ErpConnector = connect( mapStateToProps, mapDispatchToProps )(ErpConnector)


// WEBPACK FOOTER //
// ./src/components/connector/erpnextConnector.js